import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth'

var firebaseConfig = {
    apiKey: "AIzaSyAri0HtdJ-Nl_p_SmpBJ9c_y_06QrMZcx4",
    authDomain: "communityx-59d5e.firebaseapp.com",
    projectId: "communityx-59d5e",
    storageBucket: "communityx-59d5e.appspot.com",
    messagingSenderId: "940613268002",
    appId: "1:940613268002:web:54ef1b204f212cd5a4907b",
    measurementId: "G-6S8FCMPKF4"
  };
  
  //Initialize Firebase
  var firebaseApp;
  if (firebase.apps.length === 0) firebaseApp = firebase.initializeApp(firebaseConfig);
  else firebaseApp = firebase.app();

const auth = firebaseApp.auth();
const firestore = firebaseApp.firestore();
const timestamp = firebase.firestore.Timestamp;

export {firebaseApp, auth, firestore, timestamp};

